import { connect } from 'react-redux';

import {
  getMetainf,
  getProjectZoneId,
  getDashboardsUsersEvent,
  getDashboardsUsersFilter,
} from '../../../../../reducers/analyticsApp';
import {
  addFilterClause,
  copyFilter,
  removeFilter,
  removeFilterClause,
  setClausesConcatOperator,
  setFilterClauseOperator,
  setFilterClauseField,
  setFilterClauseValue,
  setFilterVisibility,
} from '../../../../../actions/dashboards/users';
import EventFilterContainer from '../../../../../components/filter/EventFilterContainer';
import { filterClauses, isNotEmptyClause } from '../../../../../utils/filter';

const mapStateToProps = (state, { unit }) => {
  const filter = getDashboardsUsersFilter(state, unit.id);

  return {
    eventId: 0,
    metainf: getMetainf(state, getDashboardsUsersEvent(state, unit.id)),
    zoneId: getProjectZoneId(state),
    concatOperator: filter.concatOperator,
    clauses: filter.clauses,
    visibility: filter.visibility,
    badgeCount: filter.clauses.filter(isNotEmptyClause).length,
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  setFilterVisibility: () => dispatch(setFilterVisibility(unit.id)),
  onAddFilterClause: () => dispatch(addFilterClause(unit.id)),
  onCopy: (clauses) => dispatch(copyFilter(unit.id, clauses)),
  onRemoveFilter: () => dispatch(removeFilter(unit.id)),
  onRemoveFilterClause: (clauseId) => dispatch(removeFilterClause(unit.id, clauseId)),
  onSelectFilterClauseField: (clauseId, field, fieldType) =>
    dispatch(setFilterClauseField(unit.id, clauseId, field, fieldType)),
  onFilterClauseValueChange: (clauseId, value) =>
    dispatch(setFilterClauseValue(unit.id, clauseId, value)),
  onSetClausesConcatOperator: (value) => dispatch(setClausesConcatOperator(unit.id, value)),
  onSelectFilterClauseOperator: (clauseId, value, resetClauseValue) =>
    dispatch(setFilterClauseOperator(unit.id, clauseId, value, resetClauseValue)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCopyFilter: (copyFilters) =>
    dispatchProps.onCopy(filterClauses(stateProps.metainf, copyFilters)),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventFilterContainer);
